import React from 'react'
import LeftIcon from '../../../Assets/Icons/LeftIcon'
import { Link ,useNavigate} from 'react-router-dom'
import './banner.css'
export default function Banner() {

    const navigate = useNavigate();
    return (
        <>
            <div className="spt-banner after-school">
                <div className="spt-banner-content after-school-content">
                    <div className='maxWidth-content'>
                    <Link onClick={()=>navigate(-1)}>
                        <LeftIcon />
                    </Link>
                    <h1 className="after-school-program"><span>After School Programs</span></h1>
                    </div>
                </div>
            </div>
        </>
    )
}
